import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";

export default function TrustFinalCTA() {
  return (
    <section
      data-testid="trust-final-cta"
      className="relative overflow-hidden py-24 md:py-32 bg-[color:var(--maqam-navy)] text-white"
    >
      <div className="absolute inset-0 islamic-pattern-dark opacity-90" aria-hidden />
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-black/30" aria-hidden />

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
        <span className="overline text-[color:var(--maqam-gold)]">The Journey Ahead</span>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
          Your journey deserves more<br className="hidden md:block" /> than just a travel package.
        </h2>
        <p className="mt-8 text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          At Maqam, we believe Umrah is more than flights and hotels. It's a sacred journey,
          and our role is to remove the stress so you can focus on what truly matters —
          <span className="text-[color:var(--maqam-gold)]"> your worship, your connection with Allah, and the memories you'll carry for a lifetime.</span>
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/contact"
            data-testid="trust-cta-reserve"
            className="btn-gold rounded-full px-7 py-3 font-semibold inline-flex items-center justify-center gap-2"
          >
            Reserve Your Seat <ArrowRight size={18} />
          </Link>
          <Link
            to="/contact"
            data-testid="trust-cta-contact"
            className="rounded-full px-7 py-3 font-semibold border border-white/60 text-white hover:bg-white hover:text-[color:var(--maqam-navy)] transition-colors inline-flex items-center justify-center gap-2"
          >
            <MessageCircle size={18} /> Contact Us
          </Link>
        </div>

        <p className="mt-5 text-xs text-white/60 leading-relaxed max-w-md mx-auto">
          Start with a short interest form. Once submitted, you'll be directed to our secure
          traveller registration form to complete your booking.
        </p>

        <p className="mt-8 text-xs uppercase tracking-[0.22em] text-white/50">
          Maqam Community · Umrah with knowledge, community &amp; care
        </p>
      </div>
    </section>
  );
}
